import { FC } from 'react';
import {Typography, Box} from "@mui/material";
import { useLangContext } from 'shared/features/Language';

export const HomeSection01: FC = () => {
  const {textData} = useLangContext();

  return (
    <Box sx={{textAlign: {lg: 'left', xs: 'center'}, marginBottom: {lg: '20px', xs: '10px'},}}>
      <Typography
        variant='body2'
        sx={{
          marginBottom: {lg: '10px', xs: '5px'},
          order: {lg:'1', xs:'2'}
        }}
      >{textData.homeMotivationShow}</Typography>
    </Box>
  );
}
